import { Routes } from '@angular/router';
import { AuthGuard } from '@app/core/guards/auth.guard';
import { passwordChangeRequiredGuard } from '@app/core/guards/password-change-required.guard';
import { UserResolver } from '@app/core/resolvers/user.resolver';
import { ForbiddenPageComponent } from '@app/shared/components/forbidden-page/forbidden-page.component';
import { ShellComponent } from '@app/shell/components/shell/shell.component';
import { NotFoundPageComponent } from '@shared/components/not-found-page/not-found-page.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/dashboard',
  },
  {
    path: 'unauthorized',
    pathMatch: 'full',
    redirectTo: '/',
  },
  {
    path: '403',
    canActivate: [AuthGuard],
    resolve: { user: UserResolver },
    component: ForbiddenPageComponent,
  },
  {
    path: '404',
    component: NotFoundPageComponent,
  },
  {
    path: '',
    canActivate: [AuthGuard],
    resolve: { user: UserResolver },
    component: ShellComponent,
    children: [
      {
        path: '',
        canMatch: [passwordChangeRequiredGuard],
        children: [
          {
            path: 'users',
            loadChildren: () => import('@app/users/users.routes').then((m) => m.routes),
          },
          {
            path: 'dashboard',
            loadChildren: () => import('@dashboard/dashboard.routes').then((m) => m.routes),
          },
          {
            path: 'profile',
            loadChildren: () => import('@app/profile/profile.routes').then((m) => m.routes),
          },
          {
            path: 'profiles',
            loadChildren: () => import('@profiles/profiles.routes').then((m) => m.routes),
          },
          {
            path: 'models',
            loadChildren: () => import('@app/models/models.routes').then((m) => m.routes),
          },
          {
            path: 'lines-of-flying',
            loadChildren: () => import('@app/lines-of-flying/lines-of-flying.routes').then((m) => m.routes),
          },
          {
            path: 'aircraft-daily-programme',
            loadChildren: () =>
              import('@aircraft-daily-programme/aircraft-daily-programme.routes').then((m) => m.routes),
          },
          {
            path: 'operational',
            loadChildren: () => import('@app/operational/operational.routes').then((m) => m.routes),
          },
          {
            path: 'release-notes',
            loadChildren: () => import('@settings/release-notes.routes').then((m) => m.routes),
          },
          {
            path: 'admin',
            loadChildren: () => import('@admin/admin.routes').then((m) => m.routes),
          },
          {
            path: 'flight-schedules',
            loadChildren: () => import('@app/flight-schedules/flight-schedules.routes').then((m) => m.routes),
          },
          {
            path: 'fleet',
            loadChildren: () => import('@app/fleet-information/fleet-information.routes').then((m) => m.routes),
          },
          {
            path: 'settings',
            loadChildren: () => import('@app/settings/settings.routes').then((m) => m.routes),
          },
        ],
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('@app/profile/components/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
